<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="col-6">
                <h4 class="card-title">Kumbara Listesi</h4>
              </div>
              <div style="text-align: right;" class="col-6 card-title">
                <a style="color:#fff" href="/#/admin/money-box">
                  <button type="submit" class="btn btn-info btn-fill float-right">
                    Yeni Kumbara
                  </button>
                </a>
              </div>
            </template>
            <a-table rowKey="id" :columns="columns" :data-source="moneyboxes.moneyboxes">
              <a slot="action" slot-scope="text, record" class="actions-area">
                <a-button type="dashed"> <a-icon type="edit" /> </a-button>
                <a-popconfirm
                  @confirm="confirmDelete(record.id)"
                  title="Silmek istediğinize emin misiniz?" 
                  ok-text="Evet" 
                  cancel-text="Hayır">
                  <a-button type="danger"> <a-icon type="delete" /> </a-button>
                </a-popconfirm>
              </a>
            </a-table>
          </card>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import Card from 'src/components/Cards/Card.vue'
  export default {
     mounted() {
      console.log("mounted moneybox list")
      const self = this
      self.$store.dispatch("Moneybox/requestMoneyboxList")
    },
    computed: {
      ...mapState({
        moneyboxes: state => state.Moneybox.moneyboxes
      }),
    },
    components: {
      Card
    },
    methods: {
      confirmDelete(moneybox_id){
        const self = this
        self.$store.dispatch("Moneybox/requestMoneyboxDelete", moneybox_id).then(()=> {
          self.$notification['success']({
            message: 'Kumbara Silme',
            description:
              'Kumbara başarılı bir şekilde silindi :)',
          });
        })
      }
    },
    data () {
      return {
        columns: [
          { title: 'ID', dataIndex: 'id', key: 'id'},
          { title: 'Kumbara Kodu', dataIndex: 'code', key: 'code'},
          { title: 'Kumbara Adı', dataIndex: 'name', key: 'name'},
          { title: 'Adres', dataIndex: 'address', key: 'address'},
          {
            title: 'İşlemler',
            key: 'operation',
            width: '20%',
            scopedSlots: { customRender: 'action' },
          },
        ]
      }
    }
  }
</script>
<style>
</style>
